import {createBrowserRouter} from "react-router-dom";

import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import MyComicsPage from '../pages/MyComicsPage';
import SharePage from '../pages/SharePage';
import Layout from './Layout';
import ProtectedRoute from './ProtectedRoute';
import AnonymousRoute from './AnonymousRoute';
import SuperAdminRoute from './SuperAdminRoute';
import SharedCollectionPage from '../pages/SharedCollectionPage';
import AboutPage from '../pages/AboutPage';
import AdminPage from '../pages/AdminPage';
import AdminSyncPage from '../pages/AdminSyncPage';
import AdminUsersPage from '../pages/AdminUsersPage';
import AdminUserPage from '../pages/AdminUserPage';
import AdminUserEditPage from '../pages/AdminUserEditPage';
import TechnicalContextPage from '../pages/TechnicalContextPage';

export const RouteNames = {
    login: '/',
    register: '/inscription',
    myComics: '/ma-collection',
    myComicsByCategory: '/ma-collection/:categoryCode',
    share: '/partager',
    sharedCollection: '/partager/:shareToken/*',
    sharedCollectionByCategory: '/partager/:shareToken/*/la-collection-de-:ownerName/:categoryCode',
    about: '/a-propos',
    admin: '/admin',
    adminSync: '/admin/synchro',
    adminUsers: '/admin/utilisateurs',
    adminUser: '/admin/utilisateurs/:id',
    adminUserEdit: '/admin/utilisateurs/:id/editer',
}

// Les routes à paramètre se construisent ici, pour que les pages n'aient pas à
// connaître la forme des chemins.
export const adminUserPath = (id) => `/admin/utilisateurs/${id}`;
export const adminUserEditPath = (id) => `/admin/utilisateurs/${id}/editer`;

const AppRouter = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                path: RouteNames.login,
                element: (
                    <AnonymousRoute>
                        <LoginPage />
                    </AnonymousRoute>
                ),
            },
            {
                path: RouteNames.register,
                element: (
                    <AnonymousRoute>
                        <RegisterPage />
                    </AnonymousRoute>
                ),
            },
            {
                path: RouteNames.myComics,
                element: (
                    <ProtectedRoute>
                        <MyComicsPage />
                    </ProtectedRoute>
                ),
            },
            {
                path: RouteNames.myComicsByCategory,
                element: (
                    <ProtectedRoute>
                        <MyComicsPage />
                    </ProtectedRoute>
                ),
            },
            {
                path: RouteNames.share,
                element: (
                    <ProtectedRoute>
                        <SharePage />
                    </ProtectedRoute>
                ),
            },
            {
                path: RouteNames.sharedCollection,
                element: (
                    <SharedCollectionPage />
                ),
            },
            {
                path: RouteNames.sharedCollectionByCategory,
                element: (
                    <SharedCollectionPage />
                ),
            },
            {
                path: RouteNames.about,
                element: <AboutPage />,
            },
            {
                path: RouteNames.admin,
                element: (
                    <SuperAdminRoute>
                        <AdminPage />
                    </SuperAdminRoute>
                ),
            },
            {
                path: RouteNames.adminSync,
                element: (
                    <SuperAdminRoute>
                        <AdminSyncPage />
                    </SuperAdminRoute>
                ),
            },
            {
                path: RouteNames.adminUsers,
                element: (
                    <SuperAdminRoute>
                        <AdminUsersPage />
                    </SuperAdminRoute>
                ),
            },
            {
                path: RouteNames.adminUser,
                element: (
                    <SuperAdminRoute>
                        <AdminUserPage />
                    </SuperAdminRoute>
                ),
            },
            {
                path: RouteNames.adminUserEdit,
                element: (
                    <SuperAdminRoute>
                        <AdminUserEditPage />
                    </SuperAdminRoute>
                ),
            },
            {
                path: '/contexte-technique',
                element: <TechnicalContextPage />,
            },
        ],
    },
]);

export default AppRouter;
